export default {
  labels: {
    google_place: 'Local no Google',
    live: 'Ativo',
    setting_up: 'Em configuração',
  },
  buttons: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    continue_setup: 'Continuar configuração',
  },
  delete_confirmation: 'Tem a certeza?',
};
